import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import querystring from 'qs';
import * as magdalaAPI from '../../actions/magdala';
import * as appDisplay from '../../actions/appDisplay';
import LoadingMessage from '../common/messages/LoadingMessage';
import PopMessage from '../common/messages/PopMessage';
import CommunitySelection from './common/CommunitySelection';
import CommunityDetails from './manage/CommunityDetails';
import stateConfig from '../../config/state';
import validator from '../../utils/validator';
import config from '../../config/config';

function ManageCommunity({ communities, magdalaAPI, appDisplay }) {
  const location = useLocation();
  const initialParams = querystring.parse(location.search.substring(1));

  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newCommunity] = useState(initialParams.newCommunity === 'true');
  const [communityId, setCommunityId] = useState(initialParams.communityId || '');
  const [community, setCommunity] = useState(null);
  const [error, setError] = useState(null);
  let initialize = config.emptyFn; 

  useEffect(() => {
    if(!init) {
      initialize();
      setInit(true);
    }
  }, [init, initialize]);

  initialize = () => {
    if(newCommunity) {
      appDisplay.displayPageMessage({
        message: 'Registration Complete!',
        type: stateConfig.messageTypes.SUCCESS,
        time: 5
      });
    }

    if(validator.isNotEmpty(communityId)) {
      setLoading(true);
      magdalaAPI.getCommunity(communityId);
    }
  }

  useEffect(() => {
    const { ids, byId } = communities;
    const communityData = byId[`${stateConfig.keys.MAGDALA_COMM}.${communityId}`];

    if(ids && communityData) {
      if(communityData.error) {
        setLoading(false);
        setError(communityData.error);
      } else {
        setLoading(false);
        setCommunity(communityData);
      }
    }
  }, [communities, communityId]);

  const onBackSelection = () => {
    setCommunityId('');
    setCommunity(null);
  };

  const onCommunitySelection = (id) => {
    setCommunityId(id);
    magdalaAPI.getCommunity(id);
  };

  const refreshCommunity = () => {
    setLoading(true);
    setCommunity(null);
    magdalaAPI.getCommunity(communityId);
  };

  const clearPopMessage = () => {
    setError(null);
  };

  return (
    <div className="ManageCommunity">
      {loading && <LoadingMessage message='Loading...' />}
      {validator.isEmpty(communityId) &&
        <CommunitySelection
          title="Select Community"
          submitLabel="Continue"
          onComplete={onCommunitySelection}
        />
      }
      {community !== null &&
        <div className="CommunityDetails">
          <CommunityDetails community={community} onBack={onBackSelection} onUpdate={refreshCommunity} />
        </div>
      }
      {error !== null &&
        <PopMessage horizontal="center" open={true} onClose={clearPopMessage}
          type={stateConfig.messageTypes.ERROR}>
          <p>An error occurred while attempting to retrieve the requested community.</p>
        </PopMessage>
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    communities: state.magdalaCommunities
  };
}

function mapDispatchToProps(dispatch) {
  return {
    magdalaAPI: bindActionCreators(magdalaAPI, dispatch),
    appDisplay: bindActionCreators(appDisplay, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageCommunity);